export default __webpack_public_path__ + "static/media/m-gif-3.17fb673e.gif";